import { contextFactory } from '@10d/tend-ui-factories';

const [LanguageContext, useLanguageContext] = contextFactory('LanguageContext', 'ru');

export { LanguageContext, useLanguageContext };
//# sourceMappingURL=LanguageContext.js.map
